export default __webpack_public_path__ + "static/media/yamm-instruction.1c23201f.webm";